import React, { FC } from 'react';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import BenefitsCard from '~/src/features/movix-new/BenefitsCard';
import Card from '~/src/features/movix-new/Card';
import { dataBenefitsBlockOne, dataHdContainer } from '~/src/features/movix-new/data';
import { getBenefitsCards } from '~/src/features/movix-new/utils';

import { Cards } from '~/src/features/movix-new/styled';
import * as ST from './styled';

export enum EMediaWidth {
    tablet = '(max-width: 1023px)',
    mobile = '(max-width: 767px)',
}

const MovixBenefits: FC = () => {
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const isUntilTablet = useMatchMedia(EMediaWidth.tablet);

    /**
     * Возвращает компоненты карточек в зависимости от разрешения
     *
     * @function
     * @name renderBenefitsCard
     * @param {boolean} isMobileLayout - условие сортировки блоков в зависимости от разрешения
     * @returns {JSX.Element[] | JSX.Element}
     */
    const renderBenefitsCard = (isMobileLayout: boolean): JSX.Element[] | JSX.Element => {
        const serialNumberCardEconomy = 3;
        return getBenefitsCards(isUntilTablet).map((elem, key) => {
            let conditionOfRender;
            if (isMobileLayout) {
                conditionOfRender = key === serialNumberCardEconomy;
            } else {
                conditionOfRender = key !== serialNumberCardEconomy;
            }
            if (conditionOfRender) {
                return <BenefitsCard key={elem.id} data={elem}/>;
            }
            return <></>;
        });
    };

    return (<ST.MovixBenefits>
        <ST.ContainerBenefits>
            <ST.BenefitsTitle>
                <h2>
                    С приставкой Movix ваш телевизор способен на большее
                </h2>
            </ST.BenefitsTitle>
            <Cards>
                {dataBenefitsBlockOne.map((item) => <Card key={item.id} item={item} />)}
            </Cards>
            {!isMobile && <ST.UltraHDContainer>
                <ST.TextContainer>
                    <ST.TitileHd>
                        {dataHdContainer.title}
                    </ST.TitileHd>
                    <ST.SubtextHd>
                        {dataHdContainer.description}
                    </ST.SubtextHd>
                </ST.TextContainer>
            </ST.UltraHDContainer>}
            {isMobile && <>
                <ST.CardsBenefits>
                    {renderBenefitsCard(true)}
                </ST.CardsBenefits>
                <Cards>
                    <Card item={dataHdContainer} />
                </Cards>
                <ST.CardsBenefits>
                    {renderBenefitsCard(false)}
                </ST.CardsBenefits>
            </>}
            {!isMobile && <ST.CardsBenefits>
                {getBenefitsCards(isUntilTablet).map((elem) => <BenefitsCard key={elem.id} data={elem}/>)}
            </ST.CardsBenefits>}
        </ST.ContainerBenefits>
    </ST.MovixBenefits>);
};

export default MovixBenefits;
